import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useState } from "react";
import { checkAdminUnlocked, unlockAdmin } from "@/lib/admin-gate.functions";

export const Route = createFileRoute("/admin_/login")({
  head: () => ({
    meta: [
      { title: "Adgang – Flâneriet" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  loader: async () => {
    const { unlocked } = await checkAdminUnlocked();
    if (unlocked) throw redirect({ to: "/admin" });
    return null;
  },
  component: AdminLogin,
});

function AdminLogin() {
  const router = useRouter();
  const unlock = useServerFn(unlockAdmin);
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setPending(true);
    setError(false);
    try {
      const { ok } = await unlock({ data: { password } });
      if (ok) {
        await router.invalidate();
        await router.navigate({ to: "/admin" });
      } else {
        setError(true);
      }
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="mx-auto max-w-md px-6 py-24">
      <p className="eyebrow">Redaktion</p>
      <h1 className="mt-2 font-serif text-4xl">Adgang</h1>
      <p className="mt-3 meta italic">Denne del af huset er lukket. Indtast adgangsordet for at træde ind.</p>
      <form onSubmit={onSubmit} className="mt-10 space-y-6">
        <div>
          <label className="eyebrow block mb-2">Adgangsord</label>
          <input
            type="password"
            autoComplete="current-password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-rule bg-transparent px-3 py-2 font-serif text-lg focus:border-bordeaux outline-none"
          />
        </div>
        {error && <p className="meta text-destructive">Forkert adgangsord.</p>}
        <button
          type="submit"
          disabled={pending || password.length === 0}
          className="font-serif text-lg text-bordeaux border-b border-bordeaux pb-1 disabled:opacity-40"
        >
          {pending ? "Åbner …" : "Træd ind"}
        </button>
      </form>
    </div>
  );
}
